<div class="d-flex flex-column w-100">
  <app-polly-manage-application-header [appHeaderName]="appHeader" (closeEvent)="closeTheRunningInstance()">
    @if (isShinyApp) {
      <div class="pr-5" slot="header-actions">
        <div class="d-flex align-items-center">
          <p-select [options]="versionNames" [(ngModel)]="selectedVersion" optionLabel="viewValue"
            (onChange)="onValueChange($event.value)" placeholder="Select a state to restore" #stateDropdown id="stateDropdown"
            [panelStyleClass]="'qubit size-small'" class="qubit size-small" dropdownIcon="polly-icon caret-down">
            <ng-template let-version #item>
              <div [pTooltip]="version.viewValue" tooltipPosition="left">{{ version.viewValue }}</div>
            </ng-template>
          </p-select>
          <polly-icon-button icon="polly-icon forward color-black" pTooltip="Refresh Bookmarks"
            tooltipPosition="bottom" class="upload-btn" (onClick)="getBookmarkVersionOptions()">
          </polly-icon-button>
      </div>
    </div>
    }
  </app-polly-manage-application-header>
  <section id="iframe-section" class="iframe-container">
    @if(iframeLoadError){
      <div class="d-flex justify-content-between align-items-center">
        <p class="iframe-error">Unable to load the application. Please try again later.</p>
      </div>
    } @else {
      <iframe id="iframeShiny" [src]="appUrl | safe : 'resourceUrl'" (load)="onIframeLoad()"
        (error)="onIframeError()" width="100%" height="100%" frameborder="0" class="iframe-shiny">
      </iframe>
    }
  </section>
</div>
